import React from 'react';
import { DownloadIcon, ExternalLinkIcon } from 'lucide-react';
export function Resume() {
  const resumeUrl = 'https://docs.google.com/document/d/1NLwo5g9d0jGgr91Ti61jqA2XaL8kwUzqsG03FjAEStw/edit?usp=sharing';
  const pdfUrl = 'https://docs.google.com/document/d/1NLwo5g9d0jGgr91Ti61jqA2XaL8kwUzqsG03FjAEStw/export?format=pdf';
  const handleDownload = () => {
    window.open(pdfUrl, '_blank');
  };
  return <div className="w-full max-w-5xl mx-auto px-6 py-12" data-id="element-83">
      <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-84">
        Resume
      </h2>
      <p className="text-gray-600 text-center mb-8" data-id="element-85">
        View my resume below or download the PDF version.
      </p>
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8" data-id="element-86">
        <div className="mb-6 border rounded overflow-hidden" data-id="element-87">
          <iframe src={`https://docs.google.com/document/d/1NLwo5g9d0jGgr91Ti61jqA2XaL8kwUzqsG03FjAEStw/preview`} className="w-full h-[800px]" title="Jake Jackson Resume" data-id="element-88" />
        </div>
        <div className="flex justify-center gap-4" data-id="element-89">
          <button onClick={handleDownload} className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium" data-id="element-90">
            <DownloadIcon size={20} data-id="element-91" />
            Download PDF
          </button>
        </div>
      </div>
    </div>;
}